var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 25,
    viewBox: "0 0 169 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.461 9.734l1.344 1.808h1.201l-.371-1.118-2.174-.69z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.461 9.734l1.344 1.808h1.201l-.371-1.118-2.174-.69z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.501 10.052l-.495 1.49h1.602l1.791-2.41-2.898.92z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.501 10.052l-.495 1.49h1.602l1.791-2.41-2.898.92z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.915 19.005l.707.95.706-.95-.706-2.125-.707 2.125z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.915 19.005l.707.95.706-.95-.706-2.125-.707 2.125z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.622 19.956l.941 1.267h3.047l-2.465-1.751-1.523.484z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.622 19.956l.941 1.267h3.047l-2.465-1.751-1.523.484z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.806 7.937l1.738 1.45 1.168-.273-.628-1.002-2.278-.175z",
    fill: "url(#paint8_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.806 7.937l1.738 1.45 1.168-.273-.628-1.002-2.278-.175z",
    fill: "url(#paint9_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.838 7.552l-.126 1.562 1.558-.366 1.166-2.753-2.598 1.557z",
    fill: "url(#paint10_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.838 7.552l-.126 1.562 1.558-.366 1.166-2.753-2.598 1.557z",
    fill: "url(#paint11_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.544 17.533l.913.763.46-1.085-1.194-1.905-.18 2.227z",
    fill: "url(#paint12_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.544 17.533l.913.763.46-1.085-1.194-1.905-.18 2.227z",
    fill: "url(#paint13_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.457 18.296l1.219 1.018 2.962-.696-2.815-1.14-1.366.818z",
    fill: "url(#paint14_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.457 18.296l1.219 1.018 2.962-.696-2.815-1.14-1.366.818z",
    fill: "url(#paint15_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.845 20.654l.188 1.16 1.071-.533.358-2.207-1.617 1.58z",
    fill: "url(#paint16_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.845 20.654l.188 1.16 1.071-.533.358-2.207-1.617 1.58z",
    fill: "url(#paint17_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.033 21.814l.25 1.547L94 24.715l-1.383-2.655-1.583-.245z",
    fill: "url(#paint18_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.033 21.814l.25 1.547L94 24.715l-1.383-2.655-1.583-.245z",
    fill: "url(#paint19_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.98 20.065l.46 1.086.913-.763-.18-2.228-1.193 1.905z",
    fill: "url(#paint20_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.98 20.065l.46 1.086.913-.763-.18-2.228-1.193 1.905z",
    fill: "url(#paint21_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.44 21.15l.613 1.448 2.962.695-1.978-2.265-1.597.123z",
    fill: "url(#paint22_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.44 21.15l.613 1.448 2.962.695-1.978-2.265-1.597.123z",
    fill: "url(#paint23_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.74 6.339l2.036 1.014 1.07-.533-.85-.83-2.256.349z",
    fill: "url(#paint24_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.74 6.339l2.036 1.014 1.07-.533-.85-.83-2.256.349z",
    fill: "url(#paint25_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.596 5.273l.25 1.547 1.428-.711.477-2.943-2.155 2.107z",
    fill: "url(#paint26_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.596 5.273l.25 1.547 1.428-.711.477-2.943-2.155 2.107z",
    fill: "url(#paint27_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.419 13.523l.357 2.207 1.07.533.188-1.16-1.615-1.58z",
    fill: "url(#paint28_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.419 13.523l.357 2.207 1.07.533.188-1.16-1.615-1.58z",
    fill: "url(#paint29_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.846 16.263l1.428.712 2.715-1.353-3.01-.466-1.133 1.107z",
    fill: "url(#paint30_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.846 16.263l1.428.712 2.715-1.353-3.01-.466-1.133 1.107z",
    fill: "url(#paint31_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.322 5.028l2.222.522.913-.763-1.024-.614-2.112.855z",
    fill: "url(#paint32_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.322 5.028l2.222.522.913-.763-1.024-.614-2.112.855z",
    fill: "url(#paint33_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.844 3.34l.614 1.447 1.218-1.017v-.002L98.436.8l-1.592 2.54z",
    fill: "url(#paint34_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.844 3.34l.614 1.447 1.218-1.017v-.002L98.436.8l-1.592 2.54z",
    fill: "url(#paint35_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.67 11.631l.874 2.064 1.168.275-.094-1.172-1.949-1.167z",
    fill: "url(#paint36_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.67 11.631l.874 2.064 1.168.275-.094-1.172-1.949-1.167z",
    fill: "url(#paint37_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.549 12.634l-.837 1.336 1.558.365 2.317-1.935-3.038.234z",
    fill: "url(#paint38_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.549 12.634l-.837 1.336 1.558.365 2.317-1.935-3.038.234z",
    fill: "url(#paint39_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.107.976l1.587 2.543 1.596.126h.001L95.92 2.12 93.107.976z",
    fill: "url(#paint40_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.107.976l1.587 2.543 1.596.126h.001L95.92 2.12 93.107.976z",
    fill: "url(#paint41_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.103 10.424l-.37 1.118h1.2l1.344-1.808-2.174.69z",
    fill: "url(#paint42_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.103 10.424l-.37 1.118h1.2l1.344-1.808-2.174.69z",
    fill: "url(#paint43_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.339 9.131l1.79 2.41h1.603l-.495-1.49-2.898-.92z",
    fill: "url(#paint44_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.339 9.131l1.79 2.41h1.603l-.495-1.49-2.898-.92z",
    fill: "url(#paint45_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.41 19.005l.707.95.706-.95-.706-2.125-.706 2.125z",
    fill: "url(#paint46_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.41 19.005l.707.95.706-.95-.706-2.125-.706 2.125z",
    fill: "url(#paint47_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 21.223h3.047l.942-1.267-1.524-.484-2.465 1.751z",
    fill: "url(#paint48_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.128 21.223h3.047l.942-1.267-1.524-.484-2.465 1.751z",
    fill: "url(#paint49_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.654 8.112l-.628 1.002 1.168.274 1.738-1.451-2.278.175z",
    fill: "url(#paint50_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.654 8.112l-.628 1.002 1.168.274 1.738-1.451-2.278.175z",
    fill: "url(#paint51_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.302 5.995l1.166 2.753 1.558.366-.126-1.562-2.598-1.557z",
    fill: "url(#paint52_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.302 5.995l1.166 2.753 1.558.366-.126-1.562-2.598-1.557z",
    fill: "url(#paint53_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.82 17.21l.46 1.086.914-.763-.18-2.228-1.193 1.906z",
    fill: "url(#paint54_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.82 17.21l.46 1.086.914-.763-.18-2.228-1.193 1.906z",
    fill: "url(#paint55_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1 18.618l2.962.696 1.219-1.018-1.366-.818-2.815 1.14z",
    fill: "url(#paint56_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1 18.618l2.962.696 1.219-1.018-1.366-.818-2.815 1.14z",
    fill: "url(#paint57_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.277 19.074l.357 2.207 1.07.533.189-1.16-1.616-1.58z",
    fill: "url(#paint58_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.277 19.074l.357 2.207 1.07.533.189-1.16-1.616-1.58z",
    fill: "url(#paint59_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.123 22.06l-1.384 2.654 2.715-1.352.25-1.548-1.581.245z",
    fill: "url(#paint60_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.123 22.06l-1.384 2.654 2.715-1.352.25-1.548-1.581.245z",
    fill: "url(#paint61_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.385 20.388l.913.763.46-1.086-1.194-1.905-.18 2.228z",
    fill: "url(#paint62_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.385 20.388l.913.763.46-1.086-1.194-1.905-.18 2.228z",
    fill: "url(#paint63_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.722 23.293l2.963-.695.614-1.447-1.598-.123-1.978 2.265z",
    fill: "url(#paint64_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.722 23.293l2.963-.695.614-1.447-1.598-.123-1.978 2.265z",
    fill: "url(#paint65_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.891 6.82l1.07.533 2.037-1.014-2.257-.35-.85.83z",
    fill: "url(#paint66_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.891 6.82l1.07.533 2.037-1.014-2.257-.35-.85.83z",
    fill: "url(#paint67_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.987 3.166l.477 2.943 1.427.71.251-1.546-2.155-2.107z",
    fill: "url(#paint68_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.987 3.166l.477 2.943 1.427.71.251-1.546-2.155-2.107z",
    fill: "url(#paint69_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.704 15.103l.187 1.16 1.07-.533.358-2.207-1.615 1.58z",
    fill: "url(#paint70_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.704 15.103l.187 1.16 1.07-.533.358-2.207-1.615 1.58z",
    fill: "url(#paint71_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.749 15.622l2.715 1.353 1.427-.712-1.133-1.107-3.01.466z",
    fill: "url(#paint72_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.749 15.622l2.715 1.353 1.427-.712-1.133-1.107-3.01.466z",
    fill: "url(#paint73_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.28 4.787l.914.763 2.222-.522-2.111-.855-1.025.614z",
    fill: "url(#paint74_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.28 4.787l.914.763 2.222-.522-2.111-.855-1.025.614z",
    fill: "url(#paint75_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.062 3.77l1.219 1.017.613-1.447L80.3.8l-.239 2.97z",
    fill: "url(#paint76_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.062 3.77l1.219 1.017.613-1.447L80.3.8l-.239 2.97z",
    fill: "url(#paint77_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.12 12.798l-.094 1.171 1.168-.274.875-2.064-1.949 1.167z",
    fill: "url(#paint78_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.12 12.798l-.094 1.171 1.168-.274.875-2.064-1.949 1.167z",
    fill: "url(#paint79_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.468 14.335l1.558-.366-.837-1.335-3.038-.234 2.317 1.935z",
    fill: "url(#paint80_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.468 14.335l1.558-.366-.837-1.335-3.038-.234 2.317 1.935z",
    fill: "url(#paint81_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.818 2.121l-.37 1.524 1.596-.126L85.632.976l-2.814 1.145z",
    fill: "url(#paint82_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.818 2.121l-.37 1.524 1.596-.126L85.632.976l-2.814 1.145z",
    fill: "url(#paint83_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8 7.856c-1.573-1.524-2.584-2.46-2.584-2.46s-1.012.936-2.585 2.46c-.843.803-2.697 2.783-2.697 4.762 0 1.311 1.095 2.381 2.472 2.381.9 0 1.686-.455 2.107-1.15.056-.054.113-.107.197-.107.14 0 .253.08.225.187-.085.722-.506 2.461-2.136 3.05h4.833c-1.63-.589-2.051-2.354-2.135-3.05-.028-.107.112-.187.224-.187.085 0 .14.053.197.107.421.695 1.208 1.15 2.107 1.15 1.377 0 2.473-1.07 2.473-2.38 0-1.954-1.883-3.96-2.698-4.763zm-1.489 3.237l.675 1.98-1.77-1.23-1.77 1.23.674-1.98-1.77-1.23h2.163l.675-1.98.674 1.98h2.163l-1.714 1.23z",
    fill: "url(#paint84_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.432 4.82c.53.048.669.412.58.995l-.381 2.414h4.852l.412-2.602c.476-2.947-.888-4.84-4.694-4.84L157.847.78l1.492.98c-1.099.793-1.74 2.056-2.018 3.772l-.159.972c-.38 2.32.222 4.138 2.125 6.52l1.522 1.944c.983 1.254 1.237 1.85 1.015 3.166l-.127.784c-.158.94-.444 1.38-1.046 1.38-.635 0-.825-.44-.698-1.286l.507-3.229h-4.978l-.571 3.51c-.539 3.48 1.49 5.473 4.978 5.473h1.176c3.742 0 5.515-2.055 6.118-5.723l.19-1.191c.381-2.32-.412-4.138-2.537-6.803l-1.617-2.006c-.793-1.097-.983-1.536-.824-2.54l.083-.59-1.772-1.096 2.726.002z",
    fill: "url(#paint85_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.917 1.776c-1.433 1.01-2.136 2.732-2.487 4.872l-1.934 11.912c-.54 3.543.792 6.207 5.2 6.207h.92c4.027 0 5.39-2.852 5.835-5.736l.761-4.765h-5.042l-.73 4.608c-.158.752-.317 1.222-.951 1.222-.634 0-.856-.438-.761-1.128l2.045-12.625-1.734-1.075 2.638.002h.055l.048.002c.601.03.749.404.658 1.157l-.603 3.605h5.043l.602-3.762c.507-3.04-.729-5.486-5.01-5.486l-6.061-.013 1.508 1.003zm-27.64.119l-3.658 22.873 5.075-.002 1.394-8.805-1.817-1.102 2.659.002c.73 0 .888.345.73 1.191l-1.102 6.974c-.158.94-.008 1.49.15 1.742h5.083l.031-.156c-.126-.376-.198-1.161-.04-2.07l1.205-7.524c.285-1.88-.761-2.821-1.522-3.197 1.237-.408 2.251-1.474 2.569-3.543l.507-3.072c.444-2.696-1.269-4.42-3.584-4.42l-9.525-.01 1.845 1.119zm4.389 4.346l-1.842-1.13 2.723.001c.635 0 .825.345.698 1.066l-.507 3.166c-.095.815-.412 1.129-1.015 1.129h-.729l.672-4.232zm9.462-5.46l1.781 1.08-6.506 22.908h4.526l.677-2.713-1.721-1.051h4.363l-.208 3.763h4.92l.464-23.987h-8.296zm3.691 8.595l-.349 7.021h-1.426l1.775-7.021zm20.009-8.59l1.868 1.15-3.671 22.83 9.864.003.803-5.029h-4.788l.601-3.744-1.848-1.134h5.765l.793-4.954h-3.71l.451-2.859-1.831-1.124 1.973.003h4.639l.815-5.142h-11.724z",
    fill: "url(#paint86_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.418.852l1.795 1.09-6.525 22.831h4.522l.675-2.696-1.669-1.004 4.298-.002-.214 3.702h4.944L24.71.85l-8.293.003zm3.667 8.588l-.349 7.022H18.31l1.776-7.021zM62.15.851l1.687 1.123c-1.399 1.114-2.114 3.008-2.498 5.46l-1.744 10.878c-.576 3.786 1.018 6.073 4.308 6.461h2.932c2.912-.385 4.586-2.635 5.19-6.304l1.776-11.035c.603-3.981-1.141-6.583-5.359-6.583h-6.292zm2.645 18.025L66.748 6.61l-1.652-1.023 2.681-.001c.698 0 .92.47.793 1.316l-1.935 12.006c-.095.596-.348 1.098-1.046 1.098-.697 0-.888-.502-.793-1.129zM28.591.851l1.503.993c-1.1.793-1.74 2.056-2.018 3.772l-.159.972c-.38 2.32.222 4.138 2.125 6.52l1.522 1.944c.983 1.254 1.237 1.85 1.015 3.166l-.127.784c-.158.94-.444 1.379-1.046 1.379-.635 0-.825-.439-.698-1.285l.507-3.23h-4.978l-.571 3.512c-.487 3.14 1.122 5.052 4.004 5.395h3.195c3.035-.356 4.53-2.337 5.073-5.646l.19-1.191c.38-2.32-.412-4.138-2.537-6.803l-1.617-2.006c-.793-1.097-.983-1.536-.824-2.54l.084-.59L31.46 4.9l2.727.001c.529.049.668.413.579.996l-.38 2.414h4.851l.412-2.602c.476-2.947-.887-4.859-4.693-4.859h-6.366zM2.654.852l1.637 1.07C2.933 2.94 2.257 4.628 1.915 6.713L0 18.505v2.878c.389 1.828 1.655 3.107 4.1 3.39h2.964c3.287-.422 4.465-3.037 4.871-5.677l.762-4.765H7.655l-.73 4.608c-.159.752-.317 1.222-.951 1.222-.634 0-.856-.438-.761-1.128L7.256 6.369 5.623 5.334h2.57c.666 0 .825.376.73 1.16l-.603 3.605h5.042l.603-3.762c.507-3.04-.73-5.486-5.01-5.486l-6.3.001zm51.775 0l1.863 1.126-1.706 10.66L53.774.851l-6.873.001h-6.79L42.005 2l-3.64 22.774h5.07l3.813-23.708 1.497.923-3.663 22.785h4.429l2.031-12.668 1.062 12.668h4.411L60.854.851h-6.425z",
    fill: "url(#paint87_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: -10.677,
    y1: 3.753,
    x2: -10.677,
    y2: 45.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: -4.707,
    y1: 3.043,
    x2: -4.707,
    y2: 49.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 110.65,
    y1: -4.834,
    x2: 169.465,
    y2: -4.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 110.65,
    y1: -4.834,
    x2: 169.465,
    y2: -4.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 77.649,
    y1: 22.365,
    x2: -4.629,
    y2: 22.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })))));
}
SvgLogo.displayName = 'Logo';
export default SvgLogo;